<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn
        id="modal-btn" 
          fab
          small
          color="primary"
          v-on="on">
          <img  src="@/assets/icon-editar.svg" alt="">
        </v-btn>
      </template>
      <v-form ref="form">
      <v-card>
        <v-card-title>
          <span class="headline">{{ this.$t("message.dialogTitle") }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-select
                  :items="this.relatedDocOptions"
                  :label="this.relatedDocTypeText"
                  :rules="typeDocRules"
                  v-model="relatedDocType"
                  @change="changeType"
                  required>
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md>
                <v-text-field
                  :label="relatedDocTypeValue"
                  v-model="relatedDocNo"
                  :rules="valueDocRules"
                  required>
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <small style="color: red;">* {{ this.$t("message.dialogRequiredFields") }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="dialog = false">{{ this.$t("message.dialogBtnClose") }}</v-btn>
          <v-btn color="blue darken-1" flat @click="updateRelatedDoc()">{{ this.$t("message.dialogBtnSave") }}</v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
  import { i18n } from "@/utils/locales/default";
  import { events, printList } from "@/main";

  export default {
    props: [ 'document', 'supplierCode', 'relatedDoc' ],
    data() {
      return {
        dialog: false,
        dialogTitle: this.$t("message.dialogTitle"),
        dialogValidationSelect: this.$t("message.dialogValidationSelect"),
        dialogValidationText: this.$t("message.dialogValidationText"),
        relatedDocOptions: [
          {
            text: this.$t("message.relatedDocPO"),
            value: "purchaseOrder",
          },
          {
            text: this.$t("message.relatedDocShipmentNum"),
            value: "shipmentNum",
          },
          {
            text: this.$t("message.relatedDocConsignment"),
            value: "consignmentSheetNum",
          },
          {
            text: "VMI",
            value: "isVMI",
          },
        ],
        relatedDocNo: this.relatedDoc.value,
        relatedDocType: this.relatedDoc.type === 'none' ? null : this.relatedDoc.type,
        relatedDocTypeText: this.$t("message.relatedDocTypeTitle"),
        relatedDocTypeValue: this.$t("message.relatedDocTypeValue"),
        typeDocRules: [
          v => !!v || this.dialogValidationSelect,
        ],
        valueDocRules: [
          v => !!v || this.dialogValidationText,
        ],
        validForm: false,
      }
    },
    methods: {
      // getLocaleString() {
      //   return i18n.locale;
      // },
      updateRelatedDoc() {
        if ( this.relatedDocType === 'purchaseOrder') {
          this.document.purchaseOrder = this.relatedDocNo;
          this.document.shipmentNum = null;
          this.document.consignmentSheetNum = null;
          this.document.isVMI = 0;
        } else if ( this.relatedDocType === 'shipmentNum' ) {
          this.document.purchaseOrder = null;
          this.document.shipmentNum = this.relatedDocNo;
          this.document.consignmentSheetNum = null;
          this.document.isVMI = 0;
        } else if ( this.relatedDocType === 'consignmentSheetNum' ) {
          this.document.purchaseOrder = null;
          this.document.shipmentNum = null;
          this.document.consignmentSheetNum = this.relatedDocNo;
          this.document.isVMI = 0;
        } else if ( this.relatedDocType === 'isVMI' ) {
          this.document.purchaseOrder = null;
          this.document.shipmentNum = null;
          this.document.consignmentSheetNum = this.relatedDocNo;          
          this.document.isVMI = 1;
        }

        const body = { document: this.document, supplierCode: this.supplierCode, isRemission: false, };

        this.$http.put(`Documents/relatedDoc/${ this.document.id }`, body )
          .then( response => {
            const { document: respDoc } = response.body;

            this.document.status = respDoc.status;
            this.snackbar( this.$t( 'message.relatedDocAssignedMessage' ) );
          }, error => {
            console.log(error);
            this.snackbar( this.$t( 'message.relatedDocErrorMessage' ) );
          });

        this.dialog = false;
      },
      changeType( option ) {
        this.relatedDocType = option;
        // console.log( this.relatedDocType );
      },
      snackbar: ( message ) => {
        events.$emit( "snackbar", message );
      },
    },
    mounted() {
    }
  }
</script>

<style>
  #modal-btn {
    width: 100% !important;
    height: 30px !important;
  }

</style>